module.exports = __webpack_public_path__ + "static/img/boy.23fc5fc5.png";